export default {
  SEARCH: 'SEARCH',
  HOME: 'HOME',
  LIVE_TV: 'LIVE_TV',
  VOD: 'VOD',
  MY_WATCHLIST: 'MY_WATCHLIST',
  PROFILE: 'PROFILE',
  DETAILS: 'DETAILS',
  SCREEN: 'SCREEN',
} as const;
